export const eventTypes = [
  { id: false, name: "All Events" },
  { id: true, name: "Events (at Home)" },
];
